module.exports = __webpack_public_path__ + "static/media/PM125.da6fedf6.png";